import { AfterViewInit, Component } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { TrackingParameters } from './models/tracking-parameter';
import { ProspectService } from 'services/prospect.service';
import { AnalyticsService } from 'services/analytics.service';

/**
 * Wrapper functions to get marketing information from tricon residental script
 *
 */
declare function parseMarketingInfo(): any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  title = 'Tricon';

  constructor(
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private route: ActivatedRoute,
    private prospectService: ProspectService,
    private readonly analyticsService: AnalyticsService) {
      this.analyticsService.init();

    // for google analytics
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url
        };

        this.gtmService.pushTag(gtmTag);
      }
    });

    this.route.queryParams.subscribe(params => {
      if (params && Object.keys(params).length !== 0) {

        if (params['unitcode']) {
          localStorage.setItem('PropertyYardiKey', params['unitcode']);
          localStorage.setItem('YardiKey', params['unitcode']);
          localStorage.removeItem('SelectedProperty');
        }
        if (params['mfunitcode']) {
          localStorage.setItem('mfunitcode', params['mfunitcode']);
          localStorage.removeItem('SelectedProperty');
        }
        if (params['unitcode'] && !params['mfunitcode']) {
          localStorage.removeItem('mfunitcode');
        }
        if (params['InvitationID']) {
          localStorage.setItem('InvitationID', params['InvitationID']);
        }
        if (params['InviteHRA']) {
          localStorage.setItem('InviteHRA', params['InviteHRA']);
        }
        if (params['stt']) {
          localStorage.setItem('SmartHomeToken', params['stt']);
        }
        if (params['att']) {
          localStorage.setItem('AnyoneHomeToken', params['att']);
        }
        if (params['desiredMoveInDate']) {
          localStorage.setItem('DesiredMoveInDate', params['desiredMoveInDate']);
        }
        if (params['desiredLeaseTerm']) {
          localStorage.setItem('DesiredLeaseTerm', params['desiredLeaseTerm']);
        }
        if (params['ReferralId']) {
          localStorage.setItem('ReferralId', params['ReferralId']);
        }
      }
    });
  }

  /**
   * After view is initialized, store the marketing parameters from tricon residential script
   */
   ngAfterViewInit(): void {
    let marketingParams = parseMarketingInfo();
    this.prospectService.getProspectInfo().subscribe(pros => {
      if(pros != null) { //prospect does not exist so capture converting marketing params
        this.captureTrackingParameters(marketingParams.converting);
      }
      else { //prospect does not exist so capture initial marketing params
        this.captureTrackingParameters(marketingParams.initial);
      }
    });
  }

  captureTrackingParameters(params) {
    let parameters = new TrackingParameters();

    parameters.Source = this.getParam(params, 'source');
    parameters.Campaign = this.getParam(params, 'campaign');
    parameters.Content = this.getParam(params, 'content');
    parameters.AdGroup = this.getParam(params, 'adgroup');
    parameters.Keyword = this.getParam(params, 'keyword');
    parameters.AdCopy = this.getParam(params, 'adcopy');
    parameters.Device = this.getParam(params, 'device');
    parameters.Medium = this.getParam(params, 'medium');

    //Only store if parameters has any value.
    if (!Object.keys(parameters).every((k) => !parameters[k])) {
      localStorage.setItem('TrackingParameters', JSON.stringify(parameters));
    }
  }

  getParam(paramsDict, name): string {

    let foundValue = null;

    if (paramsDict && name) {
      foundValue =  this.getParameterCaseInsensitive(paramsDict, name);
      if(foundValue) return foundValue;
      foundValue =  this.getParameterCaseInsensitive(paramsDict, `tricon_${name}`);
      if(foundValue) return foundValue;
      foundValue =  this.getParameterCaseInsensitive(paramsDict, `crm_${name}`);
      if(foundValue) return foundValue;
      foundValue =  this.getParameterCaseInsensitive(paramsDict, `utm_${name}`);
      if(foundValue) return foundValue;
    }

    return foundValue;
  }

  getParameterCaseInsensitive(object, key) : string {
    const asLowercase = key.toLowerCase();
    const result = object[Object.keys(object).find(k => k.toLowerCase() === asLowercase)];
    return result === undefined ? null : result;
  }

}
